module.exports = __webpack_public_path__ + "static/media/heat.5ea766e7.png";